import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store";

import axios from "axios";
Vue.use({
  install(Vue) {
    Vue.prototype.$api = axios.create({
      baseURL: "https://polymerisapi.iranpolymer.com/api/",
      timeout: 60000,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json"
      }
    });
  }
});

import moment from "vue-moment-jalaali";
Object.defineProperty(Vue.prototype, "$moment", { value: moment });

import PersianDate from "./components/shared/PersianDate";
Vue.component("persian-date", PersianDate);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.$cookies.config("7d");

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App)
}).$mount("#app");
